import { render, staticRenderFns } from "./PlanInfoCardConponent.vue?vue&type=template&id=1cd73942&scoped=true"
import script from "./PlanInfoCardConponent.vue?vue&type=script&lang=js"
export * from "./PlanInfoCardConponent.vue?vue&type=script&lang=js"
import style0 from "./PlanInfoCardConponent.vue?vue&type=style&index=0&id=1cd73942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd73942",
  null
  
)

export default component.exports